/** Anchor id for the template selection grid on /templates */
export const TEMPLATE_GRID_ID = 'choose-template';

export const TEMPLATES_PATH = '/templates';

/** Use for Get Started CTAs so users land at template selection, not a preserved scroll position */
export const TEMPLATES_CHOOSE_URL = `${TEMPLATES_PATH}#${TEMPLATE_GRID_ID}`;
